(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cutxi-bebe-discovery"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = Array.from(root.querySelectorAll('[data-baby-panel]'));
    const choices = Array.from(root.querySelectorAll('[data-baby-choice]'));
    function show(id, focus) {
      const panel = panels.find(item => item.id === id) || panels[0];
      panels.forEach(item => { item.hidden = item !== panel; });
      choices.forEach(link => {
        if (link.hash === '#' + panel.id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (focus) {
        panel.scrollIntoView({block: 'start', behavior: 'instant'});
        panel.querySelector('h2').focus({preventScroll: true});
      }
    }
    show(location.hash.slice(1), Boolean(location.hash && panels.some(p => '#' + p.id === location.hash)));
    choices.forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      show(link.hash.slice(1), true);
    }));
    window.addEventListener('hashchange', () => {
      if (root.isConnected) show(location.hash.slice(1), true);
    });
  }
  document.querySelectorAll('[data-baby-discovery]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-baby-discovery]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-blog"] && !Shopify.designMode) return;
  try {
    
function initCutxiBlog(){document.querySelectorAll('[data-cx-blog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const body=root.querySelector('[data-cx-body]'),toc=root.querySelector('[data-cx-toc]');if(body&&toc){const title=root.querySelector('h1').textContent.replace(/\s+/g,' ').trim();body.querySelectorAll('h1,h2').forEach(h=>{if(h.textContent.replace(/\s+/g,' ').trim()===title){h.remove();return}if(h.tagName==='H1'){const h2=document.createElement('h2');h2.innerHTML=h.innerHTML;if(h.id)h2.id=h.id;h.replaceWith(h2)}});const headings=[...body.querySelectorAll('h2')];if(headings.length){toc.hidden=false;headings.forEach((h,i)=>{if(!h.id){let id='cx-seccao-'+(i+1);while(document.getElementById(id))id+='-a';h.id=id}const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);const expand=headings.length>8&&i>=5;toc.querySelectorAll('ol')[expand?1:0].append(li)});if(headings.length>8){toc.querySelector('details').hidden=false;toc.querySelector('summary').textContent='Ver mais tópicos ('+(headings.length-5)+')'}}}const grid=root.querySelector('[data-cx-more-grid]'),button=root.querySelector('[data-cx-more]');if(grid&&button){let n=9;const cards=[...grid.children];const show=()=>{cards.forEach((c,i)=>c.hidden=i>=n);button.hidden=n>=cards.length};button.addEventListener('click',()=>{n+=9;show()});show()}})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCutxiBlog)}else{initCutxiBlog()}document.addEventListener('shopify:section:load',initCutxiBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-conjuntos"]) return;
  try {
    
if (!customElements.get('cutxi-conjuntos')) {
  customElements.define('cutxi-conjuntos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = Array.from(this.querySelectorAll('.cs__card'));
      this.grid = this.querySelector('.cs__grid');
      this.category = 'all';
      this.sort = this.querySelector('[data-sort]');
      this.available = this.querySelector('[data-available]');
      this.querySelector('.cs__controls').hidden = false;
      this.querySelectorAll('[data-filter]').forEach(button => {
        button.addEventListener('click', () => {
          this.category = button.dataset.filter;
          this.update();
        });
      });
      this.sort.addEventListener('change', () => this.update());
      this.available.addEventListener('change', () => this.update());
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.category = 'all';
        this.available.checked = false;
        this.update();
        this.querySelector('[data-filter="all"]').focus();
      });
      this.update();
    }
    update() {
      let visible = 0;
      const cards = [...this.cards].sort((a,b) => {
        if (this.sort.value === 'low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'high') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      cards.forEach(card => {
        card.hidden = !(this.category === 'all' || card.dataset.groups.split(' ').includes(this.category)) || (this.available.checked && card.dataset.instock !== 'true');
        if (!card.hidden) visible++;
        this.grid.appendChild(card);
      });
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      this.querySelector('[data-count]').textContent = visible;
      const label = this.querySelector('[data-count-label]');
      label.textContent = visible === 1 ? label.dataset.one : label.dataset.many;
      this.querySelector('.cs__empty').hidden = visible > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-direct-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = Array.from(root.querySelectorAll('[data-pick-panel]'));
    const links = Array.from(root.querySelectorAll('[data-pick-choice]'));
    function show(hash, focus) {
      const panel = panels.find(p => '#' + p.id === hash) || panels[0];
      panels.forEach(p => { p.hidden = p !== panel; });
      links.forEach(link => {
        if (link.hash === '#' + panel.id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (focus) {
        panel.scrollIntoView({block:'start', behavior:'instant'});
        panel.querySelector('h2').focus({preventScroll:true});
      }
    }
    show(location.hash, panels.some(p => '#' + p.id === location.hash));
    links.forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      show(link.hash, true);
    }));
    window.addEventListener('hashchange', () => {
      if (root.isConnected && (location.hash === '' || panels.some(p => '#' + p.id === location.hash))) show(location.hash, true);
    });
  }
  document.querySelectorAll('[data-cx-pick]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-cx-pick]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-escola"]) return;
  try {
    
if(!customElements.get('cutxi-escola'))customElements.define('cutxi-escola',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.sc__item')];this.filter='all';this.sort=this.querySelector('[data-sort]');this.stock=this.querySelector('input[data-stock]');this.querySelector('[data-controls]').hidden=false;this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{this.filter=b.dataset.filter;this.update()}));this.querySelector('[data-sesta]').addEventListener('click',()=>{this.filter='sesta';this.update()});this.sort.addEventListener('change',()=>this.update());this.stock.addEventListener('change',()=>this.update());this.querySelector('[data-reset]').addEventListener('click',()=>{this.filter='all';this.stock.checked=false;this.update();this.querySelector('[data-filter]').focus()});this.update()}
update(){let count=0;const grid=this.querySelector('.sc__grid');[...this.cards].sort((a,b)=>this.sort.value==='low'?+a.dataset.price-+b.dataset.price:this.sort.value==='high'?+b.dataset.price-+a.dataset.price:+a.dataset.order-+b.dataset.order).forEach(c=>{c.hidden=(this.filter!=='all'&&c.dataset.group!==this.filter)||(this.stock.checked&&c.dataset.stock!=='true');if(!c.hidden)count++;grid.appendChild(c)});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-count-label]').textContent=count===1?'artigo':'artigos';this.querySelector('.sc__empty').hidden=count>0;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.filter)))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-festas-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    var strings;try{strings=JSON.parse(root.querySelector('[data-cxf-strings]').textContent)}catch(e){return}
    var count=root.querySelector('[data-count]'), menu=root.querySelector('[data-menu-select]'), activity=root.querySelector('[data-activity-select]'), date=root.querySelector('[data-date]'), age=root.querySelector('[data-age]'), total=root.querySelector('[data-total]'), equation=root.querySelector('[data-equation]'), link=root.querySelector('[data-whatsapp]'), base=Number(root.dataset.base), minimum=Number(root.dataset.minimum);
    function money(value){return new Intl.NumberFormat(document.documentElement.lang||'pt-PT',{style:'currency',currency:'EUR',maximumFractionDigits:2,minimumFractionDigits:0}).format(value)}
    var today=new Date();date.min=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
    function update(){
      var option=menu.options[menu.selectedIndex],extra=Number(option.dataset.extra)||0,isMore=count.value==='more',n=Math.max(minimum,Number(count.value)||minimum),per=base+extra,value=n*per;
      total.textContent=isMore?strings.consult:money(value);equation.textContent=isMore?count.options[count.selectedIndex].text:n+' × '+money(per);
      var dateText=date.value?date.value.split('-').reverse().join('/'):strings.undecided;
      var message=[strings.intro,strings.count+': '+count.options[count.selectedIndex].text,strings.date+': '+dateText,strings.age+': '+(age.value||strings.undecided),strings.activity+': '+activity.options[activity.selectedIndex].text,strings.snack+': '+option.text,strings.estimate+': '+(isMore?strings.consult:money(value))];
      if(extra>0&&strings.reviewMenus)message.push(strings.review);
      link.href=root.dataset.contact.split('?')[0]+'?text='+encodeURIComponent(message.join('\n'));
    }
    [count,menu,activity,date,age].forEach(function(el){el.addEventListener('input',update);el.addEventListener('change',update)});
    root.querySelectorAll('[data-menu]').forEach(function(el){el.addEventListener('click',function(){menu.value=el.dataset.menu;update()})});
    root.querySelectorAll('[data-activity]').forEach(function(el){el.addEventListener('click',function(){activity.value=el.dataset.activity;update()})});
    link.addEventListener('click',function(event){if(!date.reportValidity()||!age.reportValidity())event.preventDefault();else update()});
    update();
  }
  function scan(){document.querySelectorAll('[data-cxf]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-festas-criativas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cutxi-party')) {
  customElements.define('cutxi-party', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const count = this.querySelector('[data-count]');
      const menu = this.querySelector('[data-menu-select]');
      const activity = this.querySelector('[data-activity]');
      const date = this.querySelector('[data-date]');
      const total = this.querySelector('[data-total]');
      const breakdown = this.querySelector('[data-breakdown]');
      const enquiry = this.querySelector('[data-enquiry]');
      const strings = JSON.parse(this.querySelector('[data-party-strings]').textContent);
      const format = new Intl.NumberFormat(this.dataset.locale || 'pt-PT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });
      const supplements = { own: 0, essential: Number(this.dataset.essential), party: Number(this.dataset.party) };
      const selectedText = field => field.options[field.selectedIndex].textContent;
      const update = () => {
        const perHead = Number(this.dataset.base) + supplements[menu.value];
        const quote = count.value === 'more';
        const sum = quote ? this.dataset.quote : format.format(Number(count.value) * perHead);
        total.textContent = sum;
        breakdown.textContent = quote ? this.dataset.quote : strings.breakdown.replace('__AMOUNT__', String(perHead));
        const message = [strings.intro, strings.age, strings.count + ': ' + selectedText(count), strings.activity + ': ' + selectedText(activity), strings.menu + ': ' + selectedText(menu), strings.date + ': ' + (date.value || strings.pending), strings.total + ': ' + sum].join('\n');
        enquiry.href = this.dataset.whatsapp + '?text=' + encodeURIComponent(message);
      };
      [count, menu, activity, date].forEach(field => field.addEventListener('change', update));
      this.querySelectorAll('[data-menu]').forEach(link => link.addEventListener('click', () => { menu.value = link.dataset.menu; update(); }));
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-festas-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cutxi-party')) {
 customElements.define('cutxi-party', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const form = this.querySelector('[data-party-form]');
   if (!form) return;
   const get = key => this.querySelector('[data-' + key + ']');
   const count = get('count'), menu = get('menu'), activity = get('activity');
   const age = get('age'), date = get('date'), total = get('total'), calculation = get('calculation');
   let labels;
   try { labels = JSON.parse(get('party-texts').textContent); } catch (error) { return; }
   const base = Number(this.dataset.base), min = Number(this.dataset.min), max = Number(this.dataset.max);
   if (![base,min,max].every(Number.isFinite) || base <= 0 || min < 1 || max < min) return;
   const formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-PT', {style:'currency',currency:'EUR',maximumFractionDigits:2});
   const selection = element => element.selectedOptions[0].textContent.trim();
   const current = () => { const n = Number(count.value); const unit = base + Number(menu.selectedOptions[0].dataset.price); const quoted = !Number.isInteger(n) || n < min || n > max; return {quoted,n,unit,text:quoted ? labels.quote : formatter.format(n * unit)}; };
   const update = () => { const value = current(); total.textContent = value.text; calculation.textContent = value.quoted ? selection(count) : labels.calculation.replace('__COUNT__',String(value.n)).replace('__UNIT__',formatter.format(value.unit)); };
   const now = new Date(); date.min = now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0');
   this.addEventListener('change', update, {signal:this.abort.signal});
   this.addEventListener('click', event => { const link = event.target.closest('[data-select-menu],[data-select-activity]'); if (!link || !this.contains(link)) return; if (link.dataset.selectMenu) menu.value = link.dataset.selectMenu; if (link.dataset.selectActivity) activity.value = link.dataset.selectActivity; update(); }, {signal:this.abort.signal});
   form.addEventListener('submit', event => {
    event.preventDefault(); if (!form.reportValidity()) return;
    let destination; try { destination = new URL(this.dataset.whatsapp); } catch (error) { return; }
    if (destination.protocol !== 'https:' || destination.hostname !== 'wa.me') return;
    const parts = date.value.split('-'); const formattedDate = [parts[2],parts[1],parts[0]].join('/');
    const lines = [labels.intro,'',labels.date + ': ' + formattedDate,labels.age + ': ' + selection(age),labels.count + ': ' + selection(count),labels.activity + ': ' + selection(activity),labels.menu + ': ' + selection(menu),labels.total + ': ' + current().text];
    if (this.dataset.approved !== 'true' && menu.value !== 'family') lines.push(labels.review);
    destination.searchParams.set('text',lines.join('\n')); window.open(destination.toString(),'_blank','noopener,noreferrer');
   }, {signal:this.abort.signal});
   get('submit').hidden = false; update();
  }
  disconnectedCallback() { if (this.abort) this.abort.abort(); this.abort = null; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-gift-finder"]) return;
  try {
    
if(!customElements.get('cutxi-gift-finder')){
customElements.define('cutxi-gift-finder',class extends HTMLElement{
connectedCallback(){if(this.initialized)return;this.initialized=true;this.labels={};this.querySelector('[data-labels]').content.querySelectorAll('[data-key]').forEach(e=>this.labels[e.dataset.key]=e.textContent);this.answers=[];this.step=0;this.cards=[...this.querySelectorAll('[data-product]')];this.intro=this.querySelector('[data-intro]');this.panel=this.querySelector('[data-panel]');this.result=this.querySelector('[data-result]');this.question=this.querySelector('[data-question]');this.querySelector('[data-start]').hidden=false;this.querySelector('[data-start]').addEventListener('click',()=>this.start());this.querySelector('[data-restart]').addEventListener('click',()=>this.start());this.querySelector('[data-more-matches]').addEventListener('click',()=>{this.visibleLimit+=3;this.displayMatches();});this.querySelector('[data-edit-budget]').addEventListener('click',()=>{this.step=2;this.answers=this.answers.slice(0,2);this.renderStep();});this.querySelector('[data-back]').addEventListener('click',()=>{if(this.step===0){this.panel.hidden=true;this.intro.hidden=false;this.querySelector('[data-start]').focus();return;}this.step--;this.answers=this.answers.slice(0,this.step);this.renderStep();});}
start(){this.answers=[];this.step=0;this.intro.hidden=true;this.result.hidden=true;this.panel.hidden=false;this.renderStep();}
renderStep(){this.panel.hidden=false;this.result.hidden=true;this.question.textContent=this.labels['quiz_q'+(this.step+1)];this.querySelector('[data-step]').textContent=this.step+1;this.panel.dataset.currentStep=this.step+1;this.querySelectorAll('.cxgf__progress span').forEach((part,index)=>part.classList.toggle('is-complete',index<=this.step));const context=this.querySelector('[data-context]');context.textContent=this.answers.slice(0,this.step).map(value=>this.labels[value]).join(' · ');context.hidden=this.step===0;this.querySelector('[data-budget-hint]').hidden=this.step!==2;let options;
if(this.step===0)options=['mae','pai','avos','bebe','crianca','padrinhos','casal','amigos','professores'];
if(this.step===1){const occasions={mae:['aniversario','agradecer','surpresa','natal'],pai:['aniversario','agradecer','surpresa','natal'],avos:['aniversario','agradecer','surpresa','natal'],bebe:['nascimento','aniversario','batizado','natal'],crianca:['aniversario','surpresa','batizado','comunhao','escola','natal'],padrinhos:['convidar','agradecer','aniversario','natal'],casal:['aniversario','surpresa','casamento','bodas','natal'],amigos:['aniversario','agradecer','surpresa','natal'],professores:['agradecer','aniversario','natal']};options=occasions[this.answers[0]];}
if(this.step===2)options=['1500','3000','5000','any'];const choices=this.querySelector('[data-choices]');choices.dataset.count=options.length;choices.classList.toggle('cxgf__choices--visual',this.step<2);choices.replaceChildren();options.forEach(value=>{const button=document.createElement('button');button.type='button';button.textContent=this.step===2?(value==='any'?this.labels.quiz_any_budget:this.labels.quiz_to+' '+this.formatMoney(Number(value))):this.labels[value];if(this.step<2){const label=document.createElement('span');label.className='cxgf__choice-label';label.textContent=button.textContent;button.replaceChildren(label);const candidates=this.cards.filter(card=>this.step===0?card.dataset.recipients.split(',').includes(value):card.dataset.recipients.split(',').includes(this.answers[0])&&card.dataset.occasions.split(',').includes(value));const portraits={mae:'chavena-de-cha-personalizada-com-nome-e-frase',pai:'quadro-moldura-palavra-pai-com-fotografia-e-frase-gosto-de-ti',avos:'ilustracao-personalizada-familia-abraco',bebe:'cesto-para-bebe-personalizado-com-nome',crianca:'pantufas-magicas-kit-personalizado-crianca',padrinhos:'convite-para-padrinho-ou-madrinha-moldura-surpresa',casal:'almofada-enches-me-o-coracao',amigos:'altar-para-os-dias-maus',professores:'box-asas-para-voar'};let card=this.step===0?candidates.find(c=>c.dataset.handle===portraits[value]):null;if(!card)card=candidates.sort((a,b)=>a.dataset.occasions.split(',').length-b.dataset.occasions.split(',').length)[0];const source=card?.querySelector('img');if(source){const photo=source.cloneNode(false);photo.alt='';photo.loading='eager';photo.sizes='(max-width:699px) 44vw, 260px';photo.removeAttribute('id');photo.className='cxgf__choice-image';button.prepend(photo);}}button.addEventListener('click',()=>{this.answers[this.step]=value;this.step++;if(this.step===3)this.showResult();else this.renderStep();});choices.appendChild(button);});this.question.focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:'auto'});}
displayMatches(){this.cards.forEach(card=>card.hidden=true);this.matches.forEach((card,index)=>{card.hidden=index>=this.visibleLimit;card.style.order=index;});const shown=Math.min(this.visibleLimit,this.matches.length);this.querySelector('[data-count]').textContent=shown===0?this.labels.quiz_zero:shown+' '+(shown===1?this.labels.quiz_one:this.labels.quiz_matched);this.querySelector('[data-more-matches]').hidden=shown>=this.matches.length;}
formatMoney(value){return new Intl.NumberFormat(document.documentElement.lang||'pt-PT',{style:'currency',currency:this.dataset.currency||'EUR',maximumFractionDigits:0}).format(value/100);}
showResult(){this.panel.hidden=true;this.result.hidden=false;const[recipient,occasion,budget]=this.answers;const cap=budget==='any'?Infinity:Number(budget);const matches=this.cards.filter(card=>card.dataset.recipients.split(',').includes(recipient)&&card.dataset.occasions.split(',').includes(occasion)&&Number(card.dataset.price)<=cap);matches.sort((a,b)=>{const score=c=>12/c.dataset.occasions.split(',').length+3/c.dataset.recipients.split(',').length;return score(b)-score(a);});const families=new Set();const first=[];const rest=[];matches.forEach(card=>{const family=card.dataset.family||card.dataset.handle;if(!families.has(family)){families.add(family);first.push(card);}else rest.push(card);});this.matches=[...first,...rest];this.visibleLimit=3;const shown=Math.min(3,this.matches.length);this.displayMatches();this.querySelector('[data-summary]').textContent=[this.labels[recipient],this.labels[occasion],budget==='any'?this.labels.quiz_any_budget:this.labels.quiz_to+' '+this.formatMoney(cap)].join(' · ');this.querySelector('[data-count]').textContent=shown===0?this.labels.quiz_zero:shown+' '+(shown===1?this.labels.quiz_one:this.labels.quiz_matched);this.querySelector('[data-empty]').hidden=shown>0;this.querySelector('[data-price-note]').hidden=shown===0;this.querySelector('.cxgf__delivery').open=false;this.querySelector('[data-result-heading]').focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:'auto'});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-nascimento"] && !Shopify.designMode) return;
  try {
    
function cutxiLoadLatest(root) {
  root.querySelectorAll('[data-cutxi-latest]').forEach(async function(section) {
    if (section.dataset.loaded) return;
    section.dataset.loaded = 'true';
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || key === 'page' || key === 'section_id' || key === 'sections') url.searchParams.delete(key);
    }
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('sections', section.dataset.cutxiLatest);
    try {
      const response = await fetch(url.toString());
      if (!response.ok) return;
      const data = await response.json();
      const html = data[section.dataset.cutxiLatest];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelector('[data-latest-products]');
      if (cards) section.querySelector('[data-latest-products]').replaceChildren(...cards.childNodes);
    } catch (error) { /* Keep the server-rendered product selection when offline. */ }
  });
}
cutxiLoadLatest(document);
document.addEventListener('shopify:section:load', function(event) { cutxiLoadLatest(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-natal-2026"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.cxnatal a[href="#cxnatal-choose"]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById('cxnatal-choose');
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  target.scrollIntoView({behavior: 'instant', block: 'start'});
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-party-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    const textNode = root.querySelector('[data-cx-text]');
    if (!textNode) return;
    let t;
    try { t = JSON.parse(textNode.textContent); } catch (error) { console.warn('Cutxi party: invalid translations', error); return; }
    const activity = root.querySelector('[data-activity]');
    const count = root.querySelector('[data-count]');
    const snack = root.querySelector('[data-snack]');
    const date = root.querySelector('[data-date]');
    const age = root.querySelector('[data-age]');
    const slot = root.querySelector('[data-slot]');
    if (!activity || !count || !snack || !date || !age || !slot) return;
    root.dataset.ready = 'true';
    let money;
    try { money = new Intl.NumberFormat(root.dataset.locale || 'pt-PT', { style:'currency', currency:'EUR', minimumFractionDigits:0, maximumFractionDigits:2 }); }
    catch (error) { money = new Intl.NumberFormat('pt-PT', { style:'currency', currency:'EUR' }); }
    const format = (value) => money.format(value);
    const set = (selector,value) => { const target = root.querySelector(selector); if (target) target.textContent = value; };
    function update() {
      const a = activity.selectedOptions[0];
      const s = snack.selectedOptions[0];
      if (!a || !s) return;
      const price = Number(a.dataset.price);
      const supplement = Number(s.dataset.price);
      const n = Number(count.value);
      const valid = Number.isInteger(n) && n >= Number(root.dataset.min) && n <= Number(root.dataset.max) && n <= 12 && Number.isFinite(price) && Number.isFinite(supplement);
      const review = root.dataset.review === 'true' && supplement > 0;
      const total = valid ? format((price + supplement) * n) : t.quote;
      set('[data-activity-total]', valid ? format(price*n) : t.quote);
      set('[data-snack-total]', valid ? format(supplement*n) : t.quote);
      set('[data-total]', total);
      set('[data-deposit]', valid ? format((price+supplement)*n/2) : t.quote);
      set('[data-unit]', Number.isFinite(price+supplement) ? format(price+supplement)+' '+t.perPerson : t.quote);
      set('[data-group]', valid ? t.group.replace('[count]',String(n)) : '');
      root.querySelector('[data-larger]').hidden = valid;
      const reviewNode = root.querySelector('[data-snack-review]');
      if (reviewNode) reviewNode.hidden = !review;
      let displayDate = t.tbd;
      let mismatch = false;
      if (/^\d{4}-\d{2}-\d{2}$/.test(date.value)) {
        const [y,m,d] = date.value.split('-');
        displayDate = d+'/'+m+'/'+y;
        const day = new Date(Number(y),Number(m)-1,Number(d),12).getDay();
        if (slot.value) mismatch = slot.value === 'weekday' ? day === 0 || day === 6 : day !== 0;
      }
      set('[data-slot-note]', mismatch ? t.slotMismatch : t.slotNote);
      const selectedSlot = slot.value ? slot.selectedOptions[0].textContent : t.tbd;
      const message = [t.intro,'',t.activity+': '+a.dataset.label,t.count+': '+(valid ? n : t.quote),t.snack+': '+s.dataset.label,t.date+': '+displayDate,t.slot+': '+selectedSlot,t.age+': '+(age.value || t.tbd),t.total+': '+total];
      if (mismatch) message.push('',t.slotMismatch);
      if (review) message.push('',t.review);
      const phone = (root.dataset.phone || '').replace(/\D/g,'');
      const whatsapp = root.querySelector('[data-whatsapp]');
      if (phone && whatsapp) whatsapp.href = 'https://wa.me/'+phone+'?text='+encodeURIComponent(message.join('\n'));
      const email = root.querySelector('[data-email-link]');
      if (email) email.href = 'mailto:'+root.dataset.email+'?subject='+encodeURIComponent(t.subject)+'&body='+encodeURIComponent(message.join('\n'));
    }
    [activity,count,snack,date,age,slot].forEach((field)=>field.addEventListener('change',update));
    root.querySelectorAll('[data-select-activity]').forEach((link)=>link.addEventListener('click',()=>{activity.value=link.dataset.selectActivity;update();}));
    root.querySelectorAll('[data-select-snack]').forEach((link)=>link.addEventListener('click',()=>{snack.value=link.dataset.selectSnack;update();}));
    update();
  }
  function boot(scope) { scope.querySelectorAll('[data-cx-festa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true}); else boot(document);
  document.addEventListener('shopify:section:load',(event)=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-recem-pais"]) return;
  try {
    
if(!customElements.get('cutxi-recem-pais'))customElements.define('cutxi-recem-pais',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.cxparents__item')];this.filter='all';this.sort=this.querySelector('[data-sort]');this.stock=this.querySelector('input[data-stock]');this.querySelector('[data-controls]').hidden=false;this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{this.filter=b.dataset.filter;this.update()}));this.sort.addEventListener('change',()=>this.update());this.stock.addEventListener('change',()=>this.update());this.querySelector('[data-reset]').addEventListener('click',()=>{this.filter='all';this.stock.checked=false;this.update();this.querySelector('[data-filter]').focus()});this.update()}
update(){let count=0;const grid=this.querySelector('.cxparents__grid');[...this.cards].sort((a,b)=>this.sort.value==='low'?+a.dataset.price-+b.dataset.price:this.sort.value==='high'?+b.dataset.price-+a.dataset.price:+a.dataset.order-+b.dataset.order).forEach(c=>{c.hidden=(this.filter!=='all'&&c.dataset.group!==this.filter)||(this.stock.checked&&c.dataset.stock!=='true');if(!c.hidden)count++;grid.appendChild(c)});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-count-label]').textContent=count===1?'artigo':'artigos';this.querySelector('.cxparents__empty').hidden=count>0;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.filter)))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-soft-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!document.body.classList.contains('template-index')) return;
  const refineLaunchers = () => {
    document.querySelectorAll('[class*="kl-teaser-"] [role="button"]').forEach(button => {
      button.querySelectorAll('p span').forEach(label => {
        if (label.textContent.trim() === '5% OFF') label.textContent = '5% de boas-vindas';
      });
      if (button.textContent.includes('5% de boas-vindas') && button.getAttribute('aria-label') !== '5% de boas-vindas') button.setAttribute('aria-label', '5% de boas-vindas');
    });
    document.querySelectorAll('button[class*="_BubbleLauncher_"]').forEach(button => {
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', 'Pontos Cutxi');
    });
  };
  refineLaunchers();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refineLaunchers(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-workshops"] && !Shopify.designMode) return;
  try {
    
function initCutxiCalendars(){document.querySelectorAll('[data-calendar-root]').forEach(root=>{const mount=root.querySelector('[data-calendar-months]');if(!mount||mount.childElementCount)return;const events=[...root.querySelectorAll('[data-event-date]')].filter(e=>/^\d{4}-\d{2}-\d{2}$/.test(e.dataset.eventDate));const months=[...new Set(events.map(e=>e.dataset.eventDate.slice(0,7)))].sort();months.forEach(key=>{const [year,month]=key.split('-').map(Number);const box=document.createElement('div');box.className='cxcal-month';const heading=document.createElement('h3');heading.textContent=new Date(year,month-1,1).toLocaleDateString('pt-PT',{month:'long',year:'numeric'});box.append(heading);const grid=document.createElement('div');grid.className='cxcal-grid';['Seg','Ter','Qua','Qui','Sex','Sáb','Dom'].forEach(day=>{const el=document.createElement('span');el.className='cxcal-weekday';el.textContent=day;grid.append(el)});const offset=(new Date(year,month-1,1).getDay()+6)%7;for(let i=0;i<offset;i++)grid.append(document.createElement('span'));for(let day=1;day<=new Date(year,month,0).getDate();day++){const date=key+'-'+String(day).padStart(2,'0');const found=events.find(e=>e.dataset.eventDate===date);const el=document.createElement(found?'a':'span');el.textContent=day;if(found){el.href='#'+found.id;el.setAttribute('aria-label',day+' — '+found.querySelector('h3').textContent);el.addEventListener('click',()=>{found.focus({preventScroll:true})})}grid.append(el)}box.append(grid);const legend=document.createElement('p');legend.className='cxcal-legend';legend.textContent='Dia com workshop · selecione para ver';box.append(legend);mount.append(box)})})}
initCutxiCalendars();document.addEventListener('shopify:section:load',initCutxiCalendars);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
